module.exports = __webpack_public_path__ + "static/img/mock-interview-xcx.ba29d8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/career_panorama/mock-interview-xcx.png
// module id = EawH
// module chunks = 1